module.exports = __webpack_public_path__ + "static/media/positionTool.1eb29a21.svg";